import { render } from "./menuLateralComponent.vue?vue&type=template&id=a3dfd668&scoped=true"
import script from "./menuLateralComponent.vue?vue&type=script&lang=js"
export * from "./menuLateralComponent.vue?vue&type=script&lang=js"

import "./menuLateralComponent.vue?vue&type=style&index=0&id=a3dfd668&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3dfd668"]])

export default __exports__